import sendEmailSaga from './sendEmailSaga'
import sendInvitationSaga from './sendInvitationSaga'

const emailSagas = [sendEmailSaga(), sendInvitationSaga()]

export default emailSagas
